import { RootState } from "app/store";
// import { DropdownProps } from "shared/components/Dropdown/model";

export type BaseSliderWrapperProps = {
  min: number;
  max: number;
  step: number;
};

export type BaseDropdownWrapperProps = {
  // options: DropdownProps["options"];
};
export type BaseRadioWrapperProps = {
  trueState: RootState["krpano"]["plugins"]["zfilter"][Filters["property"]];
  falseState: RootState["krpano"]["plugins"]["zfilter"][Filters["property"]];
};

type FilterType =
  | (BaseSliderWrapperProps & { type: "slider"; default: number })
  | (BaseDropdownWrapperProps & { type: "dropdown"; default: string })
  | (BaseRadioWrapperProps & { type: "radio"; default: string });

type Filters = {
  label: string;
  property: keyof RootState["krpano"]["plugins"]["zfilter"];
  filterOptions: FilterType;
};

type FilterSection = {
  label: string;
  filters: Filters[];
};

export const FILTERS: FilterSection[] = [
  {
    label: "RGB Vegetative Index",
    filters: [
      {
        label: "RGBVI",
        property: "rgbvi",
        filterOptions: {
          type: "slider",
          min: 0,
          max: 1,
          default: 0,
          step: 0.01,
        },
      },
      {
        label: "RGBVI Mode",
        property: "rgbvimode",
        filterOptions: {
          type: "dropdown",
          default: "ExGR",
          // options: [],
        },
      },
    ],
  },
  {
    label: "Advanced filters",
    filters: [
      {
        label: "Clip to field",
        property: "maskelement",
        filterOptions: {
          type: "radio",
          default: "hotspot[boundary_line]",
          trueState: "hotspot[boundary_line]",
          falseState: "undefined",
        },
      },
      // NOTE: Disabled for now, the client initially asked for this but then
      // said it was not needed.
      // They wanted to control all filters at once (as well as individually),
      // but this is the closest the plugin offers...
      // This only applies when clipping to the field (e.g. `maskelement` is
      // set to a hotspot), beyond that it doesn nothing.
      // {
      //   label: "Clip intensity",
      //   property: "mask",
      //   filterOptions: {
      //     type: "slider",
      //     min: 0,
      //     max: 1,
      //     default: 0,
      //     step: 0.01,
      //   },
      // },
      {
        label: "Gamma",
        property: "gamma",
        filterOptions: {
          type: "slider",
          min: 0,
          max: 4.4,
          default: 2.2,
          step: 0.01,
        },
      },
      {
        label: "Contrast",
        property: "contrast",
        filterOptions: {
          type: "slider",
          min: -1,
          max: 1,
          default: 0,
          step: 0.01,
        },
      },
      {
        label: "Exposure",
        property: "exposure",
        filterOptions: {
          type: "slider",
          min: -1,
          max: 1,
          default: 0,
          step: 0.01,
        },
      },
      {
        label: "Saturate",
        property: "saturate",
        filterOptions: {
          type: "slider",
          min: -1,
          max: 1,
          default: 0,
          step: 0.01,
        },
      },
      {
        label: "Invert",
        property: "invert",
        filterOptions: {
          type: "slider",
          min: 0,
          max: 1,
          default: 0,
          step: 0.01,
        },
      },
    ],
  },
];
